/* ---------------------------------------------------------------------------
 * Currency switcher controller (product page select + navigation drill-down).
 *
 * Loaded from snippets/currency-switcher.liquid and from the currency mode of
 * snippets/language-country-selector.liquid, so it can appear several times per
 * page: the window flag makes every copy after the first a no-op.
 *
 * Everything is delegated on document, so server-rendered markup can be replaced
 * (variant changes, price refreshes) without losing behaviour.
 * ------------------------------------------------------------------------- */
(function () {
  if (window.__currencySwitcherReady) return;
  window.__currencySwitcherReady = true;

  var SELECT = '[data-currency-switcher-select]';
  var WRAPPER = '[data-currency-switcher]';
  var GROUP = '[data-currency-group]';
  var COUNTRY = '[data-currency-country]';

  function postLocalization(code) {
    var body = new FormData();
    body.append('form_type', 'localization');
    body.append('utf8', '\u2713');
    body.append('_method', 'put');
    body.append('return_to', window.location.pathname + window.location.search);
    body.append('country_code', code);

    return fetch('/localization', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      redirect: 'manual'
    });
  }

  // Used when the background request is unavailable (the local theme preview answers 401
  // to POST /localization, for example). The country query parameter works on both the
  // storefront and the preview, and Shopify persists it in the localization cookie, so the
  // visitor still lands on the same page in the new currency instead of an error page.
  function hardFallback(code) {
    var url = new URL(window.location.href);
    url.searchParams.set('country', code);
    window.location.href = url.toString();
  }

  function refreshMoneyFormat(freshDoc, html) {
    var inline = freshDoc.querySelectorAll('script:not([src])');

    for (var i = 0; i < inline.length; i++) {
      var text = inline[i].textContent;

      if (text.indexOf('window.general') === -1) continue;

      var matched = text.match(/currency:\s*'([^']*)'/);

      if (matched && matched[1] && window.general) {
        window.general.currency = matched[1];
        if (window.Shopify) window.Shopify.money_format = matched[1];
      }
      break;
    }

    var currency = html.match(/Shopify\.currency\s*=\s*(\{[^}]*\})/);

    if (currency && window.Shopify) {
      try {
        window.Shopify.currency = JSON.parse(currency[1]);
      } catch (error) {}
    }
  }

  // Every server-rendered amount carries the .s1pr class, so replacing those nodes in
  // place refreshes prices without touching the rest of the page or its listeners.
  function refreshPrices(freshDoc) {
    var sections = document.querySelectorAll('.shopify-section[id]');

    Array.prototype.forEach.call(sections, function (section) {
      var freshSection = freshDoc.getElementById(section.id);

      if (!freshSection) return;

      var oldPrices = section.querySelectorAll('.s1pr');
      var newPrices = freshSection.querySelectorAll('.s1pr');

      if (!oldPrices.length || oldPrices.length !== newPrices.length) return;

      for (var i = 0; i < oldPrices.length; i++) {
        oldPrices[i].replaceWith(newPrices[i]);
      }
    });
  }

  // The navigation/footer selector renders its own label and active state, so it has to
  // be re-synced from the freshly rendered page. Its panel only holds buttons, and both
  // the theme and this controller rely on delegated events, so swapping is safe.
  function refreshSelectors(freshDoc) {
    var live = document.querySelectorAll('.sub.currency');
    var fresh = freshDoc.querySelectorAll('.sub.currency');

    if (!live.length || live.length !== fresh.length) return;

    for (var i = 0; i < live.length; i++) {
      var liveToggle = live[i].querySelector('a.toggle');
      var freshToggle = fresh[i].querySelector('a.toggle');

      if (liveToggle && freshToggle) liveToggle.innerHTML = freshToggle.innerHTML;

      var liveForm = live[i].querySelector('form.localization-form');
      var freshForm = fresh[i].querySelector('form.localization-form');

      if (liveForm && freshForm && liveForm.innerHTML !== freshForm.innerHTML) {
        liveForm.innerHTML = freshForm.innerHTML;
      }
    }
  }

  function reloadState() {
    var url = new URL(window.location.href);
    url.searchParams.delete('sections');
    url.searchParams.delete('section_id');
    url.hash = '';

    var current = document.querySelector('[data-current-variant]');
    var variantId = current && current.getAttribute('data-current-variant');

    if (variantId && !url.searchParams.get('variant')) {
      url.searchParams.set('variant', variantId);
    }

    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : null;
      })
      .then(function (html) {
        if (!html) return;

        var freshDoc = new DOMParser().parseFromString(html, 'text/html');

        refreshMoneyFormat(freshDoc, html);
        refreshPrices(freshDoc);
        refreshSelectors(freshDoc);
      });
  }

  function setBusy(state) {
    var wrappers = document.querySelectorAll(WRAPPER);

    Array.prototype.forEach.call(wrappers, function (wrapper) {
      wrapper.classList.toggle('is-loading', state);
    });
  }

  function switchTo(code) {
    if (!code) return;

    setBusy(true);
    postLocalization(code)
      .then(function (response) {
        var accepted = !response || response.type === 'opaqueredirect' ||
          response.status === 0 || response.status === 302 || response.ok;

        if (!accepted) throw new Error('Localization request rejected');

        return reloadState();
      })
      .catch(function () {
        hardFallback(code);
      })
      .then(function () {
        setBusy(false);
      });
  }

  function panelOf(el) {
    return el && el.closest ? el.closest('.localization-form') : null;
  }

  function collapseGroup(button) {
    var group = button.closest ? button.closest('.currency-group') : null;
    var list = group ? group.querySelector('.currency-group__list') : null;

    button.setAttribute('aria-expanded', 'false');
    if (list) list.setAttribute('hidden', '');
  }

  // The theme opens the selector on hover/click; bring the currency in use into view,
  // because it can sit below the fold of the scrollable panel.
  function revealCurrentCurrency(el) {
    var panel = panelOf(el);

    if (!panel) return;

    window.setTimeout(function () {
      var current = panel.querySelector('.currency-group.is-active');

      if (current && current.scrollIntoView) current.scrollIntoView({ block: 'nearest' });
    }, 80);
  }

  // Resolved through the DOM (not aria-controls) because the header renders its selector
  // twice, which would make generated ids ambiguous.
  function toggleGroup(button) {
    var group = button.closest ? button.closest('.currency-group') : null;
    var list = group ? group.querySelector('.currency-group__list') : null;
    var expanded = button.getAttribute('aria-expanded') === 'true';
    var panel = panelOf(button);

    // Accordion: one open currency at a time keeps the panel short, since a currency can
    // hold a long country list.
    if (!expanded && panel) {
      Array.prototype.forEach.call(panel.querySelectorAll('[data-currency-group][aria-expanded="true"]'), function (other) {
        if (other !== button) collapseGroup(other);
      });
    }

    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');

    if (!list) return;

    if (expanded) {
      list.setAttribute('hidden', '');
    } else {
      list.removeAttribute('hidden');
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    if (!target || !target.closest) return;

    var navToggle = target.closest('.sub.currency > a.toggle');

    if (navToggle) revealCurrentCurrency(navToggle);

    var group = target.closest(GROUP);

    if (group) {
      event.preventDefault();
      toggleGroup(group);
      return;
    }

    var country = target.closest(COUNTRY);

    if (!country) return;

    event.preventDefault();
    switchTo(country.value);
  });

  document.addEventListener('mouseover', function (event) {
    var toggle = event.target && event.target.closest ? event.target.closest('.sub.currency > a.toggle') : null;

    if (toggle) revealCurrentCurrency(toggle);
  });

  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest ? event.target.closest(SELECT) : null;

    if (!select) return;

    switchTo(select.value);
  });
})();
